import React from 'react';
import { DialogActions, DialogContent, Table, TableBody, TableCell, TableRow, Typography } from '@mui/material';
import { type ComparisonItem, type ComparisonItemSourceFields } from '../../../../../types/BaselineMeasurements';
import { ActionButton, Dialog } from 'app/components';
import { FormattedMessage, useIntl } from 'react-intl';
import { TranslationKeys } from '../../../../../translations';
import { ComparisonEventsListRowDetailField } from './ComparisonEventsListRowDetailField';

type ComparisonNewEmployeeDialogProps = {
  comparisonItem: ComparisonItem;
  onCloseDialog: () => void;
  onConfirmDialog: () => void;
  openNewEmployeeDialog: boolean;
  excludeFields?: Array<keyof ComparisonItemSourceFields>;
};

export const ComparisonNewEmployeeDialog = ({
  onCloseDialog,
  onConfirmDialog,
  openNewEmployeeDialog,
  comparisonItem,
  excludeFields = ['id', 'externalId'],
}: ComparisonNewEmployeeDialogProps) => {
  const fields = comparisonItem.insurerSource;
  const intl = useIntl();
  return (
    <Dialog
      open={openNewEmployeeDialog}
      title={<FormattedMessage id={TranslationKeys.employees_add} />}
      onClose={() => {
        onCloseDialog();
      }}
    >
      <DialogContent>
        <Table size="small" aria-label="differencies" sx={{ padding: 0 }}>
          <TableBody>
            {(Object.keys(fields) as Array<keyof ComparisonItemSourceFields>)
              .filter(field => !excludeFields.includes(field))
              .map(field => {
                const { insurerSource } = comparisonItem;
                const insurerValue = comparisonItem.insurerSource[field as keyof typeof insurerSource];
                const discrepanciesFields = comparisonItem.discrepancies.map(d => d.field);
                return (
                  <TableRow key={comparisonItem.insurerSource.id}>
                    <TableCell sx={{ border: 'none', py: 0.1 }} component="th" scope="row">
                      <Typography sx={{ fontWeight: 'medium', color: '#111827' }}>
                        {intl.formatMessage({ id: field })}
                      </Typography>
                    </TableCell>
                    <TableCell sx={{ border: 'none', py: 0.1 }}>
                      <ComparisonEventsListRowDetailField
                        field={field}
                        value={insurerValue}
                        discrepanciesFields={discrepanciesFields}
                      />
                    </TableCell>
                  </TableRow>
                );
              })}
          </TableBody>
        </Table>
      </DialogContent>
      <DialogActions>
        <ActionButton
          data-testid={'comparison-new-employee-confirm-button'}
          messageId={TranslationKeys.button_confirm}
          onClick={() => onConfirmDialog()}
        />
      </DialogActions>
    </Dialog>
  );
};
